import { render, staticRenderFns } from "./GameRuleView.vue?vue&type=template&id=98a111be&scoped=true"
import script from "./GameRuleView.vue?vue&type=script&lang=js"
export * from "./GameRuleView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a111be",
  null
  
)

export default component.exports